export default __webpack_public_path__ + "assets/system.c081f2ee.svg";